<template>
	<div>
		<div class="title1">短信服务 <img class="sanjiao" src="/static/qmsj/img/duanxin/xiangyou.png" alt=""> 模板设置
			<a @click="jump_m('duanxin')">
				<p class="returnBtn">返回</p>
			</a>
			<a @click="jump_m('chongzhi')">
				<p class="returnBtn" style="margin-right: 30px">充值</p>
			</a>
		</div>
		<div class="count_nei1">
			<div class="cont_title">模板设置</div>

			<ul class="temTap">
				<li v-for="(item,index) in tab_data">
					<p @click="ul_index = index" :class="ul_index == index ? 'active' : ''" class="tapP"><img :src="item.img" alt=""> {{item.name}}</p>
				</li>
			</ul>
			<div style="clear: both"></div>
			<div class="tapCon">
				<div class="systemTem tapList" v-if="ul_index == 0">
					<ul>
						<li v-for="item in database">
							<p @click="tabs(item.mb_id,0)" v-if="item.status == 1" class="useTish">已启用</p>
							<p @click="tabs(item.mb_id,1)" v-if="item.status == 0" class="useTish" style="background:gray">未启用</p>
							<p class="xinxi">
								[{{item.mb_type}}] {{item.mb_contont}}
							</p>
						</li>
					</ul>
					<div style="width: 100%;clear: both"></div>
				</div>
				<div class="myTem tapList" v-if="ul_index == 1">
					<ul>
						<li v-for="item in database">
							<!--<p class="useTish">使用中</p> -->
							<p class="xinxi">
								[{{item.mb_type}}] {{item.mb_contont}}
							</p>
						</li>
					</ul>
					<div style="width: 100%;clear: both"></div>
				</div>
			</div>

			<!--   <div class="cont_title fasong">发送设置</div>
		    <div class="shezhitix">
		        <ul>
		            <li class="shezhiTemp" onclick="xuanze(this)">
		                <label>
		                 <input class="" type="radio" name="tix">
		              <span class="content1">[活动提醒]尊敬的/XX/您好，在本店(运动宝贝-华贸城)预约的明天4月21日上午9:00的活动课
		            </span>
		                </label>
		            </li>
		            <li class="shezhiTemp" onclick="xuanze(this)">
		                <label >
		                  <input class="" type="radio" name="tix">
		                    <span  class="content1">[活动提醒]尊敬的/XX/您好，在本店(运动宝贝-华贸城)预约的明天4月21日上午9:00的活动课
		                [活动提醒]尊敬的/XX/您好，在本店(运动宝贝-华贸城)预约的明天4月21日上午9:00的活动课
		            </span>
		                </label>
		            </li>
		            <li class="shezhiTemp" onclick="xuanze(this)">
		                <label>
		                   <input  type="radio" name="tix">
		                    <span  class="content1">[活动提醒]尊敬的/XX/您好，在本店(运动宝贝-华贸城)预约的明天4月21日上午9:00的活动课
		                [活动提醒]尊敬的/XX/您好，在本店(运动宝贝-华贸城)预约的明天4月21日上午9:00的活动课
		            </span>
		                </label>
		            </li>
		        </ul>
		    </div>
		    <button class="qunfa">启动自动群发</button>
		   </div> -->

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:'',
				tab_data: [{
						name: '自动发送',
						img: '/static/qmsj/img/duanxin/shezhizi.png'
					},
					{
						name: '短信模板',
						img: '/static/qmsj/img/duanxin/xiaoren.png'
					}
				],
				ul_index: 0, //自动设置
				database:[],
			};
		},
		created(){
			this.token = this.$cookies.get('token');

			this.get_list()
		},
		methods: {
			//数据
			get_list(){
				let that = this
		 	  	$.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxzdfs',
				   type: 'post',
				   data:{
				  	  token:that.token,
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				        	that.database = data.data
				        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				})
			},
			get_list2(){
				let that = this
		 	  	$.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxmb',
				   type: 'post',
				   data:{
				  	  token:that.token,
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				        	that.database = data.data
				        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				})
			},
			tabs(i,s){
				let that = this
		 	  	$.ajax({
				   url: process.env.apiUrl + 'saas/dx/qiy',
				   type: 'post',
				   data:{
				  	  token:that.token,
				  	  mb_id:i,
				  	  type:s
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				           that.get_list()
				        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				})
			},
			//跳转页面
			jump_m(u){
				this.$router.push({path:u})
			},
		},
		watch:{
			ul_index(){
				if(this.ul_index == 1){
				   this.get_list2()
				}else{
				   this.get_list()
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../../static/qmsj/css/duanxin/chushiyangsh.css");
	@import url("../../../static/qmsj/css/duanxin/bootstrap-datetimepicker.min.css");
	@import url("../../../static/qmsj/css/duanxin/templatedesign.css");
	.clearfloat:after {
		display: block;
		clear: both;
		content: "";
		visibility: hidden;
		height: 0
	}

	.clearfloat {
		zoom: 1
	}

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.body {
		padding-left: 45px;
		padding-right: 45px;
	}

	* {
		font-size: 14px;
	}

	.cont_title {
		padding-left: 7px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		border-left: 6px solid #E6BE8A;
		margin-top: 14px;
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
	}

	.rightBox {
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
	}

	.returnBtn {
		width: 81px;
		height: 24px;
		line-height: 24px;
		color: #fff;
		background: #E6BE8A;
		border-radius: 12px;
		text-align: center;
		cursor: pointer;
		font-size: 12px;
	}

	.temTap {
		margin-top: 18px;
		list-style: none;
	}

	.temTap li {
		width: 110px;
		height: 34px;
		float: left;
		border: 1px solid #dbdbdb;
		cursor: pointer;
	}

	.temTap li p {
		width: 100%;
		height: 30px;
		line-height: 30px;
		border-top: 4px solid #fff;
		text-align: center;
	}

	.temTap li p.active {
		border-top: 4px solid #E6BE8A;
		color: #E6BE8A;
	}

	.myTem {
		width: 100%;
		height: auto;
		border: 1px solid #dbdbdb;
	}

	.myTem ul {
		width: 100%;
		height: auto;
		margin-bottom: 0;
		padding-top: 28px;
	}

	.myTem ul li {
		height: auto;
		/* line-height: 24px; */
		padding-bottom: 30px;
		padding-left: 28px;
		padding-right: 28px;
	}

	.xinxi {
		line-height: 19px;
	}

	.useTish {
		cursor: pointer;
		width: 86px;
		height: 19px;
		text-align: center;
		line-height: 19px;
		color: #fff;
		background: #E6BE8A;
		float: left;
		margin-right: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/duanxin/duanxinmob.vue